import React, { useEffect, useState } from 'react'
import { getAllCustomers } from '../../services/adv'
import { Breadcrumbs } from '../inventory/components/Breadcrumbs'
import { AddItemButton } from '../inventory/components/AddItemButton'
import BasicTable from '../../components/BasicTable'
import { useCookiesContext } from '../../contexts/CookiesContext'
import { cookiesKeyNames } from "@revbox/common-fe";
import { getMyUsers } from '../../services/micro'
import Select from "react-select";

const colWidth = {
    account_name: 250,
    account_legal_name: 290,
    account_registered_address_country_id: 100,
    account_vat_number: 180,
    created_at: 200
}

const hiddenColumns = ['cms_users', 'account_registered_address_country_id', 'account_vat_number']
const rowFields = ['id', 'account_name', 'account_legal_name', 'account_registered_address_country_id', 'account_vat_number', 'created_at']

export default function PublisherAccounts() {
    const [myUsers, setMyUsers] = useState([])
    const [selectedCMSUser, setSelectedCMSUser] = useState(null)

    const title = 'Accounts'
    const breadcrumb = 'Customers'
    const new_btn_title = 'New Acccount'
    const new_btn_redirect = '/pub/customer/new'
    const edit_redirect = '/pub/customer/edit'
    const breadcrumb_redirect = '/pub/customers/accounts'

    const { cookiesData, getPathKey } = useCookiesContext()

    const currentSkin = cookiesData[getPathKey()]?.[cookiesKeyNames.skinMode] === 'dark' ? 'dark' : ''

    useEffect(() => {
        getMyUsers().then((res) => {
            if (res.success) {
                setMyUsers([{
                    id: 0,
                    name: 'All',
                    value: 0
                }, ...res.data])
            }
        })
    }, [])

    return (
        <React.Fragment>
            <div className="main main-app d-flex flex-column p-3 p-lg-4">
                <div className="d-flex align-items-center justify-content-between mb-4">
                    <Breadcrumbs breadcrumb={breadcrumb} breadcrumb_redirect={breadcrumb_redirect} title={title} />
                    <div className="d-flex justify-content-end align-items-center">
                        <label>Browse by Manager:</label>
                        <Select
                            className='custom-select me-2'
                            onChange={(e) => {
                                setSelectedCMSUser(e.value)
                            }}
                            options={
                                myUsers.map((user) => ({
                                    label: user.name,
                                    value: user.id
                                }))
                            }
                            value={[{
                                label: myUsers.find((user) => user.id === selectedCMSUser)?.name,
                                value: selectedCMSUser
                            }]}
                            isSearchable={true}
                            placeholder={""}
                        />
                        <AddItemButton new_btn_title={new_btn_title} new_btn_redirect={new_btn_redirect} />
                    </div>
                </div>

                <BasicTable
                    getData={getAllCustomers}
                    url={edit_redirect}
                    hiddenColumns={hiddenColumns}
                    colWidth={colWidth}
                    rowFields={rowFields}
                    skin={currentSkin}
                    status={selectedCMSUser}
                />                
            </div>
        </React.Fragment>
    )
}
